<template>
	<div class="labelSelect" :style="{width:componentWidth}">
		<span :style="{color:spanColor,fontSize:spanFontSize+'px',width:spanWidth,}" class="innerSpan">
			<span style="color: red;" v-if="spanRequired">*&nbsp;</span>
			{{spanTitle}}:
		</span>
		<div class="innerP">
			<div v-for="(select,index) in selectList" :key="index" :style="{width: selectWidth}">
				<el-select v-model="value[index]" :placeholder="selectHolder[index].placeHolder" class="selectInner"
					@change="selectChange($event,index)">
					<el-option v-for="(item,index) in select" :key="index"
						:label="item.province_name?item.province_name:(item.city_name?item.city_name:item.area_name)"
						:value="item.province_id?item.province_id:(item.city_id?item.city_id:item.area_id)">
					</el-option>
				</el-select>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getLocation,
		getCity,
		getArea
	} from '../../api/moudles/user.js'
	export default {
		data() {
			return {
				selectHolder: [{
					placeHolder: '省/市'
				}, {
					placeHolder: '市/区'
				}, {
					placeHolder: '区/街道'
				}],
				selectList: [
					[],
					[],
					[]
				],
				value: [],
			}
		},
		computed: {
			// 下拉框尺寸
			selectWidth() {
				let licaoWidth = parseInt(100 / this.selectList.length - 1) + '%'
				return licaoWidth
			}
		},
		props: {
			// 默认组件宽度
			componentWidth: {
				type: String,
				default: '600px'
			},
			// span类
			spanColor: {
				type: String,
				default: '#000'
			},
			spanFontSize: {
				type: Number,
				default: 16
			},
			spanTitle: {
				type: String,
				default: '标题'
			},
			spanWidth: {
				type: String,
				default: '100px'
			},
			// 限制必填
			spanRequired: {
				default: Boolean,
				default: false
			},
			// 绑定外部值
			outInput: {
				type: Array,
				default: () => []
			}
		},
		watch: {
			outInput(newvalue) {
				this.$set(this.value, 0, newvalue[0])
				this.getCity_name(newvalue[0])
				setTimeout(() => {
					this.$set(this.value, 1, newvalue[1])
				})
				if (newvalue.length == 2) {
					this.selectList.splice(2, 1)
				}
				if (newvalue.length == 3) {
					this.new_getCity_area(newvalue[1])
					setTimeout(() => {
						this.$set(this.value, 2, newvalue[2])
					})
				}
			}
		},
		created() {
			this.getProvince_name()
		},
		methods: {
			//v-model影响了组件的props刷新 
			refAddData(newData) {
				const newvalue = newData
				this.$set(this.value, 0, newvalue[0])
				this.getCity_name(newvalue[0])
				setTimeout(() => {
					this.$set(this.value, 1, newvalue[1])
				})
				if (newvalue.length == 2) {
					this.selectList.splice(2, 1)
				}
				if (newvalue.length == 3) {
					this.new_getCity_area(newvalue[1])
					setTimeout(() => {
						this.$set(this.value, 2, newvalue[2])
					})
				}
			},
			// 获取省份
			async getProvince_name() {
				await getLocation({
					data: {},
					success: res => {
						this.$set(this.selectList, [0], res.data)
					}
				})
			},
			// 获取城市
			async getCity_name(e) {
				await getCity({
					data: {
						province_id: e
					},
					success: res => {
						// console.log('省获取市/区',res)
						this.$set(this.selectList, [1], res.data)
					}
				})
			},
			// 无赋值三级
			async new_getCity_area(e) {
				await getArea({
					data: {
						city_id: e
					},
					success: res => {
						// console.log('市获取区',res)
						if (res.data.length) {
							// 有三级添加
							this.$set(this.selectList, [2], res.data)
						}
					}
				})
			},
			// 获取区（三级）
			async getCity_area(e) {
				await getArea({
					data: {
						city_id: e
					},
					success: res => {
						// console.log('市获取区',res)
						if (res.data.length) {
							// 有三级添加
							this.$set(this.selectList, [2], res.data)
							this.$emit('placeLevel', 'false')
							const params = [this.value[0], this.value[1]]
							this.$emit('placeInfo', params)
						} else {
							// 无三级删除
							this.selectList.splice(2, 1)
							this.$emit('placeLevel', 'true')
							const params = [this.value[0], this.value[1]]
							this.$emit('placeInfo', params)
						}
					}
				})
			},
			selectChange(e, index) {
				// 第一级选择
				if (index === 0) {
					this.$set(this.selectList, [1], [])
					this.getCity_name(e)
					this.value[1] = null
					this.value[2] = null
					this.$emit('placeLevel', 'false')
					const params = [this.value[0]]
					this.$emit('placeInfo', params)
				} else if (index === 1) {
					// 二级选择
					this.getCity_area(e)
					this.value[2] = null
				} else {
					// 三级选择
					this.$emit('placeLevel', 'true')
					const params = [this.value[0], this.value[1], this.value[2]]
					this.$emit('placeInfo', params)
				}

			}
		}
	}
</script>

<style scoped>
	.labelSelect {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		margin: 10px 10px;
	}

	.innerSpan {
		display: inline-block;
		display: inherit;
		justify-content: flex-end;
	}

	.innerP {
		width: 100%;
		display: inline-block;
		display: inherit;
		justify-content: space-between;
		/* justify-content: flex-start; */
		padding-left: 20px;
	}

	.el-select {
		width: 100%
	}
</style>
